import React, { createContext, useContext } from 'react';
var ToolbarUIContext = /*#__PURE__*/createContext({
  onDropdownOpenChanged: function onDropdownOpenChanged() {},
  preventDefaultOnMouseDown: false,
  isDisabled: false,
  popupsMountPoint: undefined
});

/**
 * Access consumer specific config and state within a toolbar component
 */
export var useToolbarUI = function useToolbarUI() {
  var context = useContext(ToolbarUIContext);
  if (!context) {
    throw new Error('useToolbarUI must be used within ToolbarUIContext');
  }
  return context;
};
export var ToolbarUIProvider = function ToolbarUIProvider(_ref) {
  var children = _ref.children,
    onDropdownOpenChanged = _ref.onDropdownOpenChanged,
    preventDefaultOnMouseDown = _ref.preventDefaultOnMouseDown,
    isDisabled = _ref.isDisabled,
    popupsMountPoint = _ref.popupsMountPoint,
    popupsBoundariesElement = _ref.popupsBoundariesElement,
    popupsScrollableElement = _ref.popupsScrollableElement;
  return /*#__PURE__*/React.createElement(ToolbarUIContext.Provider, {
    value: {
      onDropdownOpenChanged: onDropdownOpenChanged,
      preventDefaultOnMouseDown: preventDefaultOnMouseDown,
      isDisabled: isDisabled,
      popupsMountPoint: popupsMountPoint,
      popupsBoundariesElement: popupsBoundariesElement,
      popupsScrollableElement: popupsScrollableElement
    }
  }, children);
};